import React from 'react';
import { WorkforceGroupFormProps } from './workforce-group-form';
import { Card, Gutter, Gap, Paragraph, Text } from '@common/components';
import { Checkbox, Input } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

type Props = {
  onUpdateInputData: WorkforceGroupFormProps['onUpdateInputData'];
  dailyMaximumHours?: number;
  loading?: boolean;
};

export const WorkforceGroupFormConsecutiveHoursTab = ({
  onUpdateInputData,
  dailyMaximumHours,
}: Props) => {
  const [checked, setChecked] = React.useState(false);
  React.useEffect(() => {
    if (dailyMaximumHours !== 24) setChecked(true);
  }, [dailyMaximumHours]);

  const onChange = (e: CheckboxChangeEvent) => {
    setChecked(e.target.checked);
    if (!e.target.checked) {
      onUpdateInputData('dailyMaximumHours', 24);
    }
  };

  return (
    <Gutter direction="vertical" size="md">
      <Card>
        <Gap vertical size="lg">
          <Checkbox checked={checked} onChange={onChange}>
            Set maximum consecutive hours
          </Checkbox>
          <Gap vertical>
            <Paragraph>
              When enabled, staff cannot claim shifts that cause them to exceed
              the set consecutive hours limit.
            </Paragraph>
            <label style={{ width: '100%' }}>
              <Gap vertical fullWidth size="xs">
                <Text>Limit (hours)</Text>
                <Input
                  type="number"
                  min={0}
                  max={24}
                  value={dailyMaximumHours}
                  onChange={(event) =>
                    onUpdateInputData(
                      'dailyMaximumHours',
                      Number(event.target.value)
                    )
                  }
                  disabled={!checked}
                  size="large"
                  style={{ maxWidth: 115 }}
                />
              </Gap>
            </label>
          </Gap>
        </Gap>
      </Card>
    </Gutter>
  );
};
